<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path stroke="#000" stroke-width="2" d="m9.216 16.96-.001-.002c-2.595-2.308-4.668-4.157-6.103-5.88C1.687 9.369 1 7.91 1 6.396 1 3.935 2.953 2 5.5 2c1.445 0 2.843.665 3.747 1.699l.753.86.753-.86A5.063 5.063 0 0 1 14.5 2C17.047 2 19 3.936 19 6.395c0 1.514-.687 2.974-2.112 4.684-1.435 1.722-3.508 3.57-6.103 5.879l-.001.001-.784.7-.784-.7Z"/></svg>
</template>

<script>
export default {
  name: "FavoritesIcon"
}
</script>
